import { isAxiosError } from 'axios';

export const handleError = (error: unknown) => {
  if (isAxiosError(error)) return error.response?.data.message;

  if (error instanceof Error) return error.message;

  return 'An unknown error ha occurred.';
};
